import Pagination from '@rc-component/pagination/lib/locale/sl_SI';
import Calendar from '../calendar/locale/sl_SI';
import DatePicker from '../date-picker/locale/sl_SI';
import TimePicker from '../time-picker/locale/sl_SI';
const localeValues = {
    locale: 'sl',
    Pagination,
    DatePicker,
    TimePicker,
    Calendar,
    global: {
        close: 'Zapri',
    },
    Table: {
        filterTitle: 'Filter',
        filterConfirm: 'Filtriraj',
        filterReset: 'Pobriši filter',
        selectAll: 'Izberi vse na trenutni strani',
        selectInvert: 'Obrni izbor na trenutni strani',
    },
    Tour: {
        Next: 'Naprej',
        Previous: 'Prejšnje',
        Finish: 'Končaj',
    },
    Modal: {
        okText: 'V redu',
        cancelText: 'Prekliči',
        justOkText: 'V redu',
    },
    Popconfirm: {
        okText: 'v redu',
        cancelText: 'Prekliči',
    },
    Transfer: {
        titles: ['', ''],
        searchPlaceholder: 'Išči tukaj',
        itemUnit: 'Objekt',
        itemsUnit: 'Objektov',
    },
    Upload: {
        uploading: 'Nalaganje...',
        removeFile: 'Odstrani datoteko',
        uploadError: 'Napaka pri nalaganju',
        previewFile: 'Predogled datoteke',
        downloadFile: 'Prenos datoteke',
    },
    Empty: {
        description: 'Ni podatkov',
    },
};
export default localeValues;
